import React, { FunctionComponent, MouseEvent } from 'react'

import ReactQuill, { Quill } from 'react-quill-new'

import 'react-quill-new/dist/quill.snow.css'

import { StyledEditor } from './styled-rich-text-editor'

const Font = Quill.import('formats/font') as any
Font.whitelist = ['roboto-condensed', 'roboto', 'lora']
Quill.register(Font, true)

interface Props {
  value?: string
  onChange?: (value: string) => void
  readOnly?: boolean
  maxHeight?: string
}

const formats = ['font', 'header', 'bold', 'italic', 'underline', 'strike', 'list', 'align', 'color', 'background', 'link']

const toolbarOptions = [
  [{ font: ['roboto-condensed', 'roboto', 'lora'] }, { header: [1, 2, 3, 4, false] }],
  ['bold', 'italic', 'underline', 'strike'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ align: [] }],
  [{ color: [] }, { background: [] }],
  ['link'],
  ['clean'],
]

const modules = {
  toolbar: toolbarOptions,
}

const RichTextEditor: FunctionComponent<Props> = ({ value = '', onChange, readOnly = false, maxHeight }) => {
  const handleChange = (content: string): void => {
    if (onChange) {
      onChange(content)
    }
  }

  const handleClick = (e: MouseEvent<HTMLDivElement>): void => {
    const target = e.target as HTMLElement
    if (target.tagName === 'A' && readOnly) {
      const href = target.getAttribute('href')
      if (href && !/^(https?:\/\/|mailto:|tel:)/i.test(href)) {
        e.preventDefault()
        window.open(`https://${href}`, '_blank', 'noopener,noreferrer')
      }
    }
  }

  return (
    <StyledEditor $readOnly={readOnly} $maxHeight={maxHeight} onClick={handleClick}>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={handleChange}
        readOnly={readOnly}
        modules={readOnly ? { toolbar: false } : modules}
        formats={formats}
      />
    </StyledEditor>
  )
}

export default RichTextEditor
